export function getAdvertisingAgreement({ jwt }) {
  return fetch(
    `${process.env.REACT_APP_API_ENDPOINT}/d2c/getAdvertisingAgreements`,
    {
      method: "GET",
      mode: "cors",
      headers: { Authorization: `Bearer ${jwt}` },
    }
  )
    .then(response => {
      if (response.ok) {
        return response.json()
      }
      throw response
    })
    .then(payload => ({ payload }))
    .catch(error => ({ error }))
}

export function putAdvertisingAgreement({ jwt, params }) {
  return fetch(
    `${process.env.REACT_APP_API_ENDPOINT}/d2c/putAdvertisingAgreements`,
    {
      method: "PUT",
      body: JSON.stringify({
        advertisingAgree: params.advertisingAgree,
        ...(params.cpEntry !== undefined ? { cp_entry: params.cpEntry } : {}),
      }),
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: `Bearer ${jwt}`,
      },
    }
  )
    .then(response => {
      //D2C側のAPIはresponseがないので必ずifを削除する
      if (response.ok) {
        return response.json()
      }
      throw response
    })
    .then(payload => ({ payload }))
    .catch(error => ({ error }))
}
